
export const PROJET_ACTIF_FILTER = "filters[isActif]=true";
export const PROJET_HORS_NEGOCIATION_FILTER = "filters[$and][0][$or][0][enNegotiation][$null]=true&filters[$and][0][$or][1][enNegotiation]=false";
export const PROJET_SELECTIONNABLE_FILTER = PROJET_ACTIF_FILTER + "&" + PROJET_HORS_NEGOCIATION_FILTER;

export function withProjetHorsNegociation(filter: string): string {
	if (!filter || !filter.includes(PROJET_ACTIF_FILTER) || filter.includes("[enNegotiation]")) return filter;
	return filter + "&" + PROJET_HORS_NEGOCIATION_FILTER;
}
